module.exports = __webpack_public_path__ + "img/indu_1.6696d094.png";